import styled from 'styled-components';

export const Container = styled.div`
  background: #fff;
  box-shadow: 0px 2px 4px rgba(24, 39, 75, 0.12),
    0px 4px 4px rgba(24, 39, 75, 0.08);
  border-radius: 4px;
  width: 350px;
  height: max-content;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .container_links {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 20px;
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1%;
    letter-spacing: -0.02em;
    font-feature-settings: 'ss01' on;
    color: #102693;
  }

  .containerButtons {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: var(--spacement-medium);
  }
`;

export const Form = styled.form`
  padding: 24px;
  font-weight: 200;
  color: var(--neutral-3);
`;

export const Header = styled.div`
  border-bottom: 1.5px solid rgba(24, 39, 75, 0.08);
  padding: 24px;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--neutral-4);
`;
